import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';


import { ApiResponse, FlujoLinks, PromptRequest, PromptResponse, ExploreRequest } from 'src/app/models/verioner-url'; 
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionerUrlService {
  private baseUrl = `${env.apiCerberoUrl}`;
  httpClient: any;

  constructor(private http: HttpClient) { }

  /* generarVersion(url: Generator) {
    //console.log('servicio', `${this.baseUrl}/request?event=generador-texto`, url);
    return this.http.post<ApiResponse>(`${this.baseUrl}/request?event=generador-texto`, url);
  } */

  newVersion(IArequest: PromptRequest) {
    //console.log('servicio nueva version', `${this.baseUrl}/request?event=solve-one-prompt`, IArequest);
    return this.http.post<PromptResponse>(`${this.baseUrl}/request?event=solve-one-prompt`,IArequest);
    
  }  

  startVersioner(data: FlujoLinks) {
    return this.http.post<ApiResponse>(`${this.baseUrl}/request?event=versionador`, data);
  }

  exploreNewVersion(data: ExploreRequest) {
    return this.http.post<ApiResponse>(`${this.baseUrl}/request?event=versionador-investigar`, data);
  }

  queryVersionerStatus(uuid: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/request?event=versionador-consultar-estado&uuid=${uuid}`);
  }

}
